const discovered = [];

export default class CQAnalytics {
    _tracker;
    _trackIndex;

    /**
     * @param {*} tracker - The cqanalytics tracker object
     * @param {number} trackIndex - The trackIndex the tracker should start with
     */
    constructor(tracker, trackIndex = -1) {
        this._tracker = tracker;
        this._trackIndex = trackIndex;
    }

    get trackIndex() {
        return this._trackIndex;
    }

    /**
     * track an url or event
     * @param {string} type - The type of track
     * @param {*} payload - The tracking payload
     * @param {number} trackIndex - The index of the track event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    track(type, payload, trackIndex) {
        this._trackIndex = trackIndex;
        if (type === 'event') {
            return this._trackEvent();
        } else if(type === 'page') {
            return this._trackPage();
        }
    }

    /**
     * track an url
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackPage() {
        this._tracker.record({
            event: 'pageView',
            values: {},
        });
        return Promise.resolve(true);
    }

    /**
     * track an event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackEvent() {
        //TODO is there event tracking in cqanalytics?
        return Promise.resolve(true);
    }

    /**
     * destroy the tracker instance and clean up if necessary
     */
    destroy() {
        discovered.length = 0;
    }

    /**
     * repeat calls to this function will not discover the same tracker again
     * @param {number} trackIndex - The trackIndex the tracker should start with
     * @returns - A promise resolving an array of wrapper instances for discovered tracker
     */
    static discover(trackIndex = -1) {
        return new Promise((resolve, reject) => {
            if (
                !~discovered.indexOf("CQ_Analytics") && 
                window.CQ_Analytics &&
			    window.CQ_Analytics.Sitecatalyst &&
                window.CQ_Analytics.record
            ) {
                discovered.push("CQ_Analytics");
                resolve([new CQAnalytics(window.CQ_Analytics, trackIndex)]);
            } else {
                resolve([])
            }
        });
    }

    /**
     * initialize general purpose things like the tracker's library js
     */
    static init() {
        return Promise.resolve();
    }

    /**
     * @param {*} options - The tracker options 
     * @returns - A promise resolving the wrapper instance
     */
    static create({id, domain, name}) {
        return new Promise((resolve, reject) => {
            //TODO
        })
    }
}


// WEBPACK FOOTER //
// ./lib/analytics/tracker-cqanalytics.js